import { useEffect } from 'react';
import { BACK4APP_DOT_COM_DASHBOARD_URL } from '../settings';
import LoadingMessage from './LoadingMessage';

/**
 * Where a bare `/` or `/apps` goes: My Apps on the dashboard.
 *
 * This dashboard used to answer `/apps` with an app list of its own. The
 * account-wide list is the one every "All apps" in here already points at, so
 * a second one — reachable only by typing the address — is gone, and the
 * address forwards.
 *
 * Mounted outside `App` on purpose: `App` loads the user and sends a visitor
 * who is not logged in to the login page with this address to return to. The
 * dashboard asks for the login itself, and returns to the right place.
 */
const RedirectToMyApps = () => {
  useEffect(() => {
    window.location.replace(`${BACK4APP_DOT_COM_DASHBOARD_URL}/apps`);
  }, []);

  return <LoadingMessage message="Loading…" />;
};

export default RedirectToMyApps;
